__turbopack_context__.v({
  "filterButton": "NewsCategoryNav-module-scss-module__GwBWuq__filterButton",
  "filterButtonActive": "NewsCategoryNav-module-scss-module__GwBWuq__filterButtonActive",
  "filters": "NewsCategoryNav-module-scss-module__GwBWuq__filters",
  "root": "NewsCategoryNav-module-scss-module__GwBWuq__root",
  "title": "NewsCategoryNav-module-scss-module__GwBWuq__title",
});
